const baseApiUrl = process.env.REACT_APP_API_URL;


export const centralAdminUrls = {
  getRoles: baseApiUrl + "Admin/GetRoles",
  getUsers: baseApiUrl + "Admin/GetUsers?",
  getScenarioCriticality: baseApiUrl + "Scenario/GetScenarioCriticality",
  saveScenarioRoleMapping: baseApiUrl + "Scenario/SaveScenarioRoleMapping?",
  getInDemandDataReport: baseApiUrl + "Admin/GetInDemandDataReport?",
  getSKUSwitchSearch: baseApiUrl + "ProductGroup/GetSKUSwitchSearch?",
  getSKUbyCountry: baseApiUrl + "Admin/GetSKUbyCountry?",
  getFolderIdByName: baseApiUrl + "Moveit/GetFolderIdByName_Rv3?",
  getFolderContent: baseApiUrl + "Moveit/GetFolderContent?",
  updateAndSaveUser: baseApiUrl + "Admin/SaveUser",
  deleteUsers: baseApiUrl + "Admin/DeleteUsers",
  saveUser: baseApiUrl + "Admin/SaveUser",
  exportInDemandReport: baseApiUrl + "Analyze/ExportInDemandReport?",
  downloadFile: baseApiUrl + "Moveit/DownloadFile?",
  getDatasources: baseApiUrl + "Admin/GetDatasources",
  exportSkuReplacementData: baseApiUrl + "ProductGroup/ExportFile?",
  updateSKUSwitch: baseApiUrl + "ProductGroup/UpdateSKUSwitch",
  getGroupScenario: baseApiUrl + "Admin/GetGroupOrScenarioDetails?",
  updateGroupOrScenarioActivation:
    baseApiUrl + "Admin/UpdateGroupOrScenarioActivation?",
  listUpdateGroupOrScenario: baseApiUrl + "Admin/ListUpdateGroupOrScenario",
  GetCustomerNumber : baseApiUrl + "Admin/GetCustomerNumber?",
  GetSalesOrderNumberLineItem : baseApiUrl + "Admin/GetSalesOrderNumberLineItem",
  getDataSourcesRecords : baseApiUrl + "Admin/GetDataSourceRecords",
  ModifyDataSourcesRows : baseApiUrl + "Admin/ModifyDataSourcesRows",
  getSKUforUOM: baseApiUrl + "ProductGroup/GetSKUsListsForUOM?",
  updateUOMSKU: baseApiUrl + "ProductGroup/UpdateSKUUOM",
  getPeriod:baseApiUrl + "Admin/GetPeriods",
  GetSalesOrderNumberLineItemForDelete : baseApiUrl + "Admin/GetSalesOrderLineItem",
  getDataSourcesRecordsForDelete : baseApiUrl + "Admin/GetDataSourceRows",
  DeleteDataSourceRows : baseApiUrl + "Admin/DeleteDataSourceRows",
};
